import { render } from "./OrganogramMap.vue?vue&type=template&id=9a34692e&scoped=true"
import script from "./OrganogramMap.vue?vue&type=script&lang=js"
export * from "./OrganogramMap.vue?vue&type=script&lang=js"

import "./OrganogramMap.vue?vue&type=style&index=0&id=9a34692e&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a34692e"]])

export default __exports__